import React from "react";
import { useParams } from "react-router-dom";
import { MyExpApiUtil } from "shared/api/MyExpApiUtil";
import { ContactContextMyExpBehaviour } from "shared/contactContext/behaviour/contactContextMyExpBehaviour";
import { CreateUpdateContactContext } from "shared/contactContext/CreateUpdateContactContext";
import { PremiumContactModes } from "shared/enums/ContactMode";

export default function CreateUpdateContextLocationForMyExperience() {
  const baseApiUtil = React.useMemo(() => {
    return new MyExpApiUtil();
  }, []);
  const { contextId = "", eventParticipantId } = useParams();
  return (
    <CreateUpdateContactContext
      baseApiUtil={baseApiUtil}
      contextId={contextId}
      requesterId={eventParticipantId}
      contactContextBehavioiur={new ContactContextMyExpBehaviour()}
      initialFormStateDisabled={false}
      applicableContactModes={PremiumContactModes}
      canShowStatusButtons={false}
    />
  );
}
